// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var MM_wrk_editor = require("../worker/MM_wrk_editor.res.js");
var PaginationCmp = require("../ui-utils/PaginationCmp.res.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.res.js");
var MM_cmp_user_stmt = require("./MM_cmp_user_stmt.res.js");
var MM_editor_history = require("../worker/MM_editor_history.res.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.res.js");
var Static_XML_to_HTML = require("../utils/Static_XML_to_HTML.res.js");
var Paper = require("@mui/material/Paper").default;
var AppBar = require("@mui/material/AppBar").default;
var Button = require("@mui/material/Button").default;

function MM_cmp_editor_hist(props) {
  var onRestore = props.onRestore;
  var stepsPerPage = props.stepsPerPage;
  var viewOptions = props.viewOptions;
  var onClose = props.onClose;
  var hist = props.hist;
  var editorState = props.editorState;
  var modalRef = props.modalRef;
  var match = React.useState(function () {
        if (MM_editor_history.editorHistLength(hist) > 0) {
          return 0;
        } else {
          return -1;
        }
      });
  var setCurIdx = match[1];
  var curIdx = match[0];
  var match$1 = React.useState(function () {
        return MM_editor_history.editorHistGetSnapshotPreview(hist, curIdx, editorState);
      });
  var setCurEditorState = match$1[1];
  var curEditorState = match$1[0];
  var match$2 = React.useState(function () {
        return 0;
      });
  var setPageIdx = match$2[1];
  var pageIdx = match$2[0];
  var actGoToPage = function (pageIdx) {
    setPageIdx(function (param) {
          return pageIdx;
        });
  };
  var actChangeCurIdx = function (newCurIdx) {
    if (-1 <= newCurIdx && newCurIdx <= (MM_editor_history.editorHistLength(hist) - 1 | 0)) {
      setCurIdx(function (param) {
            return newCurIdx;
          });
      return setCurEditorState(function (param) {
                  return MM_editor_history.editorHistGetSnapshotPreview(hist, newCurIdx, editorState);
                });
    }
    
  };
  var actPrev = function () {
    actChangeCurIdx(curIdx + 1 | 0);
  };
  var actNext = function () {
    actChangeCurIdx(curIdx - 1 | 0);
  };
  var prevIsDisabled = curIdx === (MM_editor_history.editorHistLength(hist) - 1 | 0);
  var nextIsDisabled = curIdx === -1;
  var rndButtons = function () {
    return React.createElement(Expln_React_Row.make, {
                alignItems: "center",
                style: {
                  padding: "4px"
                },
                children: Caml_option.some(null)
              }, React.createElement(Button, {
                    onClick: (function (param) {
                        onRestore(curIdx);
                      }),
                    variant: "contained",
                    disabled: nextIsDisabled,
                    color: "grey",
                    children: "Restore this"
                  }), React.createElement(Button, {
                    onClick: (function (param) {
                        onClose();
                      }),
                    children: "Close"
                  }), React.createElement(Expln_React_Row.make, {
                    alignItems: "center",
                    spacing: 0,
                    children: Caml_option.some(null)
                  }, React.createElement(Button, {
                        onClick: (function (param) {
                            actPrev();
                          }),
                        disabled: prevIsDisabled,
                        children: "< PREV"
                      }), React.createElement("span", undefined, String(curIdx + 1 | 0)), React.createElement(Button, {
                        onClick: (function (param) {
                            actNext();
                          }),
                        disabled: nextIsDisabled,
                        children: "NEXT >"
                      })));
  };
  var rndMultilineText = function (text, renderer) {
    var style = text.trim() === "" ? ({
          padding: "4px"
        }) : ({
          padding: "0px"
        });
    return React.createElement(Paper, {
                style: style,
                variant: "outlined",
                children: Caml_option.some(text.trim() === "" || Belt_Option.isNone(renderer) ? React.createElement("pre", undefined, text) : Belt_Option.getExn(renderer)(text))
              });
  };
  var rndDescr = function (editorState) {
    return React.createElement(Expln_React_Row.make, {
                alignItems: "flex-start",
                spacing: 1,
                style: {
                  marginTop: "12px",
                  marginLeft: "7px"
                },
                children: Caml_option.some(null)
              }, React.createElement("span", undefined, "Description"), rndMultilineText(editorState.descr, (function (str) {
                      return React.createElement(Static_XML_to_HTML.make, {
                                  xmlStr: str
                                });
                    })));
  };
  var rndVars = function (editorState) {
    return React.createElement(Expln_React_Row.make, {
                alignItems: "flex-start",
                spacing: 1,
                style: {
                  marginTop: "3px",
                  marginLeft: "7px"
                },
                children: Caml_option.some(null)
              }, React.createElement("span", undefined, "Variables"), rndMultilineText(editorState.varsText, undefined));
  };
  var rndDisj = function (editorState) {
    return React.createElement(Expln_React_Row.make, {
                alignItems: "flex-start",
                spacing: 1,
                style: {
                  marginTop: "3px",
                  marginLeft: "7px"
                },
                children: Caml_option.some(null)
              }, React.createElement("span", undefined, "Disjoints"), rndMultilineText(editorState.disjText, undefined));
  };
  var rndPagination = function (editorState) {
    var paginationIsRequired = editorState.stmts.length > stepsPerPage;
    if (!paginationIsRequired) {
      return null;
    }
    var stepsPerPage$1 = Math.max(1, Math.min(stepsPerPage, 1000));
    var numOfPages = Math.ceil(editorState.stmts.length / stepsPerPage$1) | 0;
    var maxPageIdx = numOfPages - 1 | 0;
    var pageIdx$1 = Math.max(0, Math.min(pageIdx, maxPageIdx));
    return React.createElement("div", {
                style: {
                  padding: "5px"
                }
              }, React.createElement(PaginationCmp.make, {
                    numOfPages: numOfPages,
                    pageIdx: pageIdx$1,
                    siblingCount: 1000,
                    itemsPerPage: stepsPerPage$1,
                    showGoToPage: false,
                    showItemsPerPage: false,
                    onPageIdxChange: actGoToPage
                  }));
  };
  var rndStmts = function (editorState) {
    var numOfPages = Math.ceil(editorState.stmts.length / stepsPerPage) | 0;
    var maxPageIdx = numOfPages - 1 | 0;
    var pageIdx$1 = Math.max(0, Math.min(pageIdx, maxPageIdx));
    var stmtBeginIdx = Math.imul(pageIdx$1, stepsPerPage);
    var stmtEndIdx = (stmtBeginIdx + stepsPerPage | 0) - 1 | 0;
    return React.createElement(Expln_React_Column.make, {
                spacing: 0,
                children: Caml_option.some(editorState.stmts.filter(function (param, i) {
                            if (stmtBeginIdx <= i) {
                              return i <= stmtEndIdx;
                            } else {
                              return false;
                            }
                          }).map(function (__x) {
                          return React.createElement(MM_cmp_user_stmt.make, {
                                      modalRef: modalRef,
                                      settingsVer: editorState.settingsV,
                                      settings: editorState.settings,
                                      preCtxVer: editorState.preCtxV,
                                      varsText: editorState.varsText,
                                      wrkCtx: editorState.wrkCtx,
                                      frms: editorState.frms,
                                      parenCnt: editorState.parenCnt,
                                      syntaxTypes: editorState.syntaxTypes,
                                      parensMap: editorState.parensMap,
                                      typeColors: editorState.typeColors,
                                      preCtxColors: editorState.preCtxColors,
                                      wrkCtxColors: editorState.wrkCtxColors,
                                      editStmtsByLeftClick: editorState.settings.editStmtsByLeftClick,
                                      longClickEnabled: editorState.settings.longClickEnabled,
                                      longClickDelayMs: editorState.settings.longClickDelayMs,
                                      defaultStmtType: editorState.settings.defaultStmtType,
                                      showVisByDefault: editorState.settings.showVisByDefault,
                                      viewOptions: {
                                        showCheckbox: false,
                                        showLabel: viewOptions.showLabel,
                                        showType: viewOptions.showType,
                                        showJstf: viewOptions.showJstf,
                                        inlineMode: viewOptions.inlineMode,
                                        smallBtns: viewOptions.smallBtns
                                      },
                                      readOnly: true,
                                      parenAc: false,
                                      toggleParenAc: (function () {
                                          
                                        }),
                                      stmt: __x,
                                      onLabelEditRequested: (function () {
                                          
                                        }),
                                      onLabelEditDone: (function (param) {
                                          
                                        }),
                                      onLabelEditCancel: (function (param) {
                                          
                                        }),
                                      onTypEditRequested: (function () {
                                          
                                        }),
                                      onTypEditDone: (function (param, param$1) {
                                          
                                        }),
                                      onContEditRequested: (function () {
                                          
                                        }),
                                      onContEditDone: (function (param) {
                                          
                                        }),
                                      onContEditCancel: (function (param) {
                                          
                                        }),
                                      onSyntaxTreeUpdatedWithoutContentChange: (function (newStmtCont) {
                                          var stmtId = __x.id;
                                          var update = function (__x) {
                                            return MM_wrk_editor.setStmtCont(__x, stmtId, newStmtCont);
                                          };
                                          setCurEditorState(function (stRes) {
                                                if (stRes.TAG === "Ok") {
                                                  return {
                                                          TAG: "Ok",
                                                          _0: update(stRes._0)
                                                        };
                                                } else {
                                                  return stRes;
                                                }
                                              });
                                        }),
                                      onJstfEditRequested: (function () {
                                          
                                        }),
                                      onJstfEditDone: (function (param) {
                                          
                                        }),
                                      onJstfEditCancel: (function (param) {
                                          
                                        }),
                                      checkboxDisabled: true,
                                      checkboxChecked: false,
                                      checkboxOnChange: (function (param) {
                                          
                                        }),
                                      onGenerateProof: (function () {
                                          
                                        }),
                                      onDebug: (function () {
                                          
                                        }),
                                      addStmtAbove: (function (param) {
                                          
                                        }),
                                      addStmtBelow: (function (param) {
                                          
                                        }),
                                      setShowTabs: (function (param) {
                                          
                                        }),
                                      openFrameExplorer: (function (param) {
                                          
                                        })
                                    });
                        }))
              });
  };
  var rndEditorState = function () {
    if (curEditorState.TAG !== "Ok") {
      return React.createElement("pre", {
                  style: {
                    color: "red"
                  }
                }, "Error reading editor history: " + curEditorState._0);
    }
    var editorState = curEditorState._0;
    return React.createElement(Expln_React_Column.make, {
                spacing: 0,
                children: Caml_option.some(null)
              }, rndDescr(editorState), rndVars(editorState), rndDisj(editorState), rndPagination(editorState), rndStmts(editorState), rndPagination(editorState));
  };
  return React.createElement(Paper, {
              style: {
                padding: "10px"
              },
              children: Caml_option.some(null)
            }, React.createElement(AppBar, {
                  position: "sticky",
                  color: "white",
                  children: rndButtons()
                }), rndEditorState());
}

var make = MM_cmp_editor_hist;

exports.make = make;
/* react Not a pure module */
